import axios from "@/axios";
// import * as types from '../mutation-types';

export default {
    namespaced: true,

    state: {},

    actions: {
        fetchEvaluation({ commit }, { employeeIds, sectionId, jobDescriptionId, evaluationType, fromDate, toDate, date, whereNonDeleted, page, perPage }) {
            var urlSearchParams = new URLSearchParams()
            var params = { sectionId, jobDescriptionId, evaluationType, fromDate, toDate, date, whereNonDeleted, page, perPage }
            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
            })
            employeeIds.forEach(id => {
                urlSearchParams.append('employeeId', id)
            })
            return axios.get('/evaluation/employees', { params: urlSearchParams }).then((response) => {
                return {
                    data: response.data,
                    total: parseInt(response.headers['x-pagination-total-count'])
                }
            })
        },

        fetchEvaluationByEmployeeId({ commit }, { id }) {
            return axios.get(`evaluation/employee/${id}`).then(({ data }) => {
                return data
            })
        },

        fetchAll() {
            return axios.get('/evaluation').then(({ data }) => {
                return data
            })
        },

        create({ commit }, { data }) {  
            return axios.post('/evaluation', data).then((data) => {
                return data
            })
        },

        createNewType({ commit }, { data }) {
            return axios.post('/evaluation/type', data).then((data) => {
                return data
            })
        },

        createNewCategory({ commit }, { data }) {
            return axios.post('/evaluation/standard/category', data).then((data) => {
                return data
            })
        },

        createEvaluationForEmployee({ commit }, { data }) {
            return axios.post('/evaluation/employee/evaluation', data).then((data) => {
                return data
            })
        }

    },

    mutation: {},

    getter: {}
}